module.exports = __webpack_public_path__ + "img/toxseek_logo.4bd2606a.png";